import { ApiMetaDataDTO, UserDTO } from 'declarations'
import { useQuery, UseQueryResult } from '@tanstack/react-query'
import { client } from 'services/helpers/apiConfig'

type ResponseDTO = {
  code: number
  data: UserDTO
  api_metadata: ApiMetaDataDTO
}

export const useUserReadQuery = (
  userName?: string
): UseQueryResult<ResponseDTO, unknown> => {
  return useQuery({
    queryKey: ['user', 'read', userName],
    queryFn: async () => {
      const un = userName ? userName : localStorage.getItem('username') || ''

      if (un !== '') {
        const { data } = await client.get<ResponseDTO>(`/user/read/${un}`)

        if (data.code === 200) {
          return data
        } else {
          throw { message: 'User not found' }
        }
      } else {
        throw { message: 'User not found' }
      }
    },

    refetchOnMount: false,
    refetchOnWindowFocus: false,
    retry: false,
  })
}
